import Button from '../common/forms/Button';
import Icon from '../common/Icon';

export const DeveloperBackButton = ({
  setActiveTool,
}: {
  setActiveTool(arg: null): void;
}) => {
  return (
    <Button
      hierarchy="secondary-gray"
      icon={<Icon id="arrow-circle-left" />}
      iconPlacement="leading"
      onClick={() => {
        setActiveTool(null);
      }}
      size="md"
    >
      Back
    </Button>
  );
};
